import { render, staticRenderFns } from "./TableUBAActions.vue?vue&type=template&id=7ae42bc8&scoped=true&"
import script from "./TableUBAActions.vue?vue&type=script&lang=js&"
export * from "./TableUBAActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae42bc8",
  null
  
)

export default component.exports